import { useEffect, useState } from 'react';
import { MemoryRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_URL } from '../config/api';
import logService from '../services/logService';
import Repairs from './Repairs';
import './MobileSheets.css';
import './MobileTamirat.css';

// iOS admin uygulamasının WebView'da açtığı Tamirat ekranı: /mobile/tamirat
// Web'deki Repairs'ın kendisi (aynı filtreler, sayılar, modallar) mobileApp modunda çizilir;
// ana görünüm RepairsMobileHome, modallar telefona göre MobileTamirat.css ile düzenlenir.
// Oturum token'ı iOS'tan gelir (window.__akikAuthToken → utils/apiAuth.js); kullanıcı bilgisi
// yetki/mağaza ve log kayıtları için /auth/verify'dan alınır. index.js bu yolu App olmadan render eder.
// Fişler sayfasından bir tamirat kaydına dokununca /mobile/tamirat?repair=ID&from=fisler açılır:
// o kaydın detayı doğrudan açılır, üstte Fişler'e dönüş çubuğu gösterilir.
const params = new URLSearchParams(window.location.search);
const openRepairId = Number(params.get('repair')) || null;
const fromFisler = params.get('from') === 'fisler';

function MobileTamirat() {
  const [user, setUser] = useState(null);
  const [authFailed, setAuthFailed] = useState(false);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.add('mtm-html');
    document.title = 'Tamirat';
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover');
    return () => root.classList.remove('mtm-html');
  }, []);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_URL}/auth/verify`)
      .then(r => (r.ok ? r.json() : null))
      .then(data => {
        if (cancelled) return;
        if (!data?.user) { setAuthFailed(true); return; }
        setUser(data.user);
        logService.setContext(data.user, null);
      })
      .catch(() => { if (!cancelled) setAuthFailed(true); });
    return () => { cancelled = true; };
  }, []);

  return (
    <MemoryRouter initialEntries={[{ pathname: '/', state: openRepairId ? { openRepairId } : undefined }]}>
      <div className="mtm-page">
        {fromFisler && (
          <button type="button" className="mtm-back" onClick={() => window.history.back()}>
            ‹ Fişler
          </button>
        )}
        {/* Kullanıcı gelmeden render edilirse mağaza filtresi "kendi mağazası" sanıp boş liste gösterir */}
        {user ? (
          <Repairs user={user} selectedStore={null} mobileApp />
        ) : (
          <div className="mtm-status">
            {authFailed ? 'Oturum doğrulanamadı. Aşağı çekip yenileyin veya uygulamaya tekrar giriş yapın.' : 'Yükleniyor…'}
          </div>
        )}
      </div>
      <ToastContainer
        position="top-center"
        autoClose={2500}
        hideProgressBar
        newestOnTop
        closeOnClick
        draggable
        pauseOnFocusLoss={false}
        theme="colored"
        limit={2}
      />
    </MemoryRouter>
  );
}

export default MobileTamirat;
